<template>
  <nav class="navigation navigation--main">
    <ul>
      <template v-for="item in navigationMainsOrdered">
        <li :key="item.id">
          <router-link :to="{ name: 'home-sub', params: { target: `${item.target}`, title: item.title }}" @click.native="didClickNavigation()">
            {{ item.title }}
          </router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
import query from '@/services/api/query';

export default {
  name: 'navigation-main',
  data() {
    return {
      navigationMains: [],
    };
  },
  computed: {
    navigationMainsOrdered() {
      let items = this.navigationMains;
      return items.sort((a,b) => a.id - b.id)
    },
  },
  methods: {
    didClickNavigation() {
      this.$eventBus.$emit(this.$events('GLOBAL.HIDE_NAVIGATION'));
    }
  },
  apollo: {
    navigationMains: query.navigation_main,
  },
};
</script>
